import React, { useContext, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";
import { Language } from "../../App";


const ShareModal = ({ isOpen, toggle, type, postId, }) => {
  const { lang } = useContext(Language)
  const shareUrl = `https://medicalradar.es/shareable/${type}/${postId}`;
  const [copyStatus, setCopyStatus] = useState("");

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopyStatus(lang.copied_to_clipboard);
    } catch (error) {
      console.error("Failed to copy text: ", error);
      setCopyStatus("Failed to copy!");
    }

    // Reset the status after a delay
    setTimeout(() => setCopyStatus(""), 2000);
  };
  return (
    <div>

      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalHeader toggle={toggle}>{lang.share_this_post}</ModalHeader>
        <ModalBody>
          <div className="sharemodal-body-wrapper">
            <h3>{lang.copy_to_clipboard}</h3>
            <textarea
              rows="3"
              cols="50"
              value={shareUrl}
              readOnly
              className="sharemodal-textarea"
            />

            <br />
            <button
              onClick={handleCopy}
              className="sharemodal-copy-btn"
            >
              {lang.copy}
            </button>
            <p className="sharemodal-copy-status">{copyStatus}</p>
          </div>
        </ModalBody>

        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            {lang.close || "Close"}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ShareModal;
